<div class="relative overflow-x-auto py-6">
  <div class="mb-6">
    <h2 class="text-2xl font-semibold text-blue-600 text-center">Package Details</h2>
  </div>
  <div>
    <app-package-filter/>
  </div>

  <div class="flex justify-end py-4">
    <a
      routerLink="/package/create"
      class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition duration-200 transform hover:scale-105"
    >
      Create Package
    </a>
  </div>

  <div class="overflow-hidden bg-white shadow-lg rounded-lg">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead
        class="text-xs text-white uppercase tracking-wider bg-gradient-to-r from-blue-500 to-blue-600 dark:bg-blue-700">
        <tr>
          <th scope="col" class="px-6 py-3">Id</th>
          <th scope="col" class="px-6 py-3">Name</th>
          <th scope="col" class="px-6 py-3">Description</th>
          <th scope="col" class="px-6 py-3">Component</th>
          <th scope="col" class="px-6 py-3">Total Amount</th>
          <th scope="col" class="px-6 py-3">Min Amount</th>
          <th scope="col" class="px-6 py-3">Status</th>
          <th scope="col" class="px-6 py-3">Action</th>
        </tr>
      </thead>
      <tbody divide-y divide-gray-200>
        <tr *ngFor="let package of packages" class="bg-white dark:bg-gray-800 dark:border-gray-700 border-gray-200
                   hover:bg-blue-50 dark:hover:bg-gray-700 hover:shadow-lg transition-all cursor-pointer">
          <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white cursor-pointer"
            (click)="openDetailsDrawer(package)">
            {{ package.id }}
          </th>
          <td class="px-6 py-4">{{ package.name }}</td>
          <td class="px-6 py-4">{{ package.description | truncate: 100 }}</td>
          <td class="px-6 py-4">
            <ul *ngIf="package.components.length > 0">
              <li *ngFor="let component of package.components">
                <strong>name:</strong> {{ component.name }} - <strong>price:</strong> {{ component.price }}
              </li>
            </ul>
            <span *ngIf="!package.components || package.components.length === 0" class="italic text-gray-600">No components available</span>
          </td>
          <td class="px-6 py-4">{{ package.total_amount }}</td>
          <td class="px-6 py-4">{{ package.min_amount }}</td>
          <td class="px-6 py-4">
            <span class="inline-block px-3 py-1 text-xs font-semibold rounded-lg" [ngClass]="{
                'bg-green-500 text-white': package.status === 'active',
                'bg-red-500 text-white': package.status === 'inactive',
                'bg-yellow-500 text-white': package.status === 'pending'
              }">
              {{ package.status | titlecase }}
            </span>
          </td>
          <td class="px-6 py-4 flex space-x-3">
            <a routerLink="/package/{{ package.id }}/edit"
              class="inline-block text-green-500 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition duration-200 mx-2"
              title="Edit Package">
              <i class="fa fa-edit fa-lg"></i>
            </a>

            <a (click)="deletePackage($event, package.id)"
              class="inline-block text-red-500 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition duration-200 mx-2"
              title="Delete Package">
              <i class="fa fa-trash fa-lg"></i>
            </a>

            <a (click)="openDetailsDrawer(package)"
              class="inline-block text-blue-500 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-200 mx-2"
              title="View Details">
              <i class="fa fa-eye fa-lg"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>




<div *ngIf="isDrawerOpen" class="fixed inset-0 z-50 bg-gray-500 bg-opacity-50" (click)="closeDetailsDrawer()"></div>

<div *ngIf="isDrawerOpen"
  class="fixed right-0 top-0 h-full w-1/3 bg-white shadow-xl transition-transform duration-500 transform ease-in-out"
  [ngClass]="{ 'translate-x-0': isDrawerOpen, 'translate-x-full': !isDrawerOpen }">

  <div class="p-6 space-y-6 border-l-4 border-gray-300 rounded-lg shadow-2xl transform transition-all">

    <div class="flex justify-between items-center mb-6 border-b border-gray-300 pb-4">
      <h2 class="text-2xl font-semibold text-blue-600 text-center">Package Details</h2>
      <button (click)="closeDetailsDrawer()"
        class="text-gray-600 hover:text-gray-900 transition duration-200 ease-in-out focus:outline-none">
        <i class="fas fa-times fa-lg"></i>
      </button>
    </div>

    <div *ngIf="selectedPackage" class="space-y-6">

      <div
        class="flex items-center space-x-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition duration-200">
        <p class="font-medium text-gray-800">ID:</p>
        <span class="text-gray-600">{{ selectedPackage.id }}</span>
      </div>

      <div
        class="flex items-center space-x-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition duration-200">
        <p class="font-medium text-gray-800">Name:</p>
        <span class="text-gray-600">{{ selectedPackage.name }}</span>
      </div>

      <div
        class="flex items-center space-x-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition duration-200">
        <p class="font-medium text-gray-800">Description:</p>
        <span class="text-gray-600">{{ selectedPackage.description }}</span>
      </div>

      <div *ngIf="selectedPackage.components?.length" class="space-y-4">
        <p class="font-medium text-gray-800">Components:</p>
        <ul class="space-y-4">
          <li *ngFor="let component of selectedPackage.components"
            class="p-4 border-b border-gray-200 rounded-lg hover:bg-gray-100 transition duration-200">
            <div class="flex justify-between">
              <span class="text-gray-700">{{ component.name }}</span>
              <span class="text-gray-600">{{ component.price | currency }}</span>
            </div>
          </li>
        </ul>
      </div>
      <p *ngIf="!selectedPackage.components?.length" class="italic text-gray-500">No components available</p>

      <div class="flex justify-between p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition duration-200">
        <div class="flex items-center space-x-4">
          <p class="font-medium text-gray-800">Total Amount:</p>
          <span class="text-gray-600">{{ selectedPackage.total_amount | currency }}</span>
        </div>
        <div class="flex items-center space-x-4">
          <p class="font-medium text-gray-800">Min Amount:</p>
          <span class="text-gray-600">{{ selectedPackage.min_amount | currency }}</span>
        </div>
      </div>

      <div class="flex justify-between p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition duration-200">
        <div class="flex items-center space-x-4">
          <p class="font-medium text-gray-800">Creator Id:</p>
          <span class="text-gray-600">{{ selectedPackage.creator_id }}</span>
        </div>
        <div class="flex items-center space-x-4">
          <p class="font-medium text-gray-800">Approval Id:</p>
          <span class="text-gray-600">{{ selectedPackage.approval_id }}</span>
        </div>
      </div>

      <div
        class="flex items-center space-x-4 p-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition duration-200">
        <p class="font-medium text-gray-800">Status:</p>
        <span class="text-gray-600">{{ selectedPackage.status | titlecase }}</span>
      </div>
    </div>

    <div class="mt-6 flex justify-center">
      <button (click)="closeDetailsDrawer()"
        class="bg-blue-500 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-600 focus:outline-none transition duration-200 ease-in-out transform hover:scale-105">
        <i class="fas fa-times-circle"></i> Close
      </button>
    </div>
  </div>
</div>
